import axios from "axios";
import Cookies from "js-cookie";
import { notification } from "antd";

let isUnauthorizedRedirectInProgress = false;

const redirectToLogin = () => {
	if (isUnauthorizedRedirectInProgress) {
		return;
	}

	isUnauthorizedRedirectInProgress = true;
	Cookies.remove("mgltoken");
	Cookies.remove("mgltokenprevious");

	notification.error({
		message: "Sesja wygasła. Zostaniesz wylogowany.",
		key: "session-expired",
	});

	window.location.replace(
		process.env.REACT_APP_FRONT_URL +
			"/#/login?app=" +
			process.env.REACT_APP_APP_KEY,
	);
};

// Interceptor request
axios.interceptors.request.use(
	(config) => {
		const token = Cookies.get("mgltoken");

		if (token) {
			config.headers["Authorization"] = token;
		}

		config.headers["App"] = process.env.REACT_APP_APP_KEY;
		return config;
	},
	(error) => Promise.reject(error),
);

// Interceptor response
axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			redirectToLogin();
		}
		return Promise.reject(error);
	},
);

export default axios;
